<template>
  <a-card :bordered="false" title="短信设置">
    <a-tabs defaultActiveKey="1" @change="callback">
      <div class="extra-wrapper" slot="tabBarExtraContent">
        <div class="extra-item">
          <a-button v-if="tabsKey == 1" type="primary" @click="showTemplate">添加模板</a-button>
          <a-button v-else-if="tabsKey == 2" type="primary" @click="showShield">添加屏蔽</a-button>
          <a-button v-else type="primary" @click="showSignature">添加签名</a-button>
        </div>
      </div>
      <a-tab-pane tab="模板设置" key="1">
        <TemplateComponent ref="childOne"></TemplateComponent>
      </a-tab-pane>
      <a-tab-pane tab="屏蔽发送" key="2">
        <SmsShieldingSendComponent ref="childThree"></SmsShieldingSendComponent>
      </a-tab-pane>
      <a-tab-pane tab="签名设置" key="3" forceRender>
        <SmsComponent ref="childTwo"></SmsComponent>
      </a-tab-pane>
    </a-tabs>
    <!-- 添加短信模板 -->
    <a-modal
      title="添加短信模板"
      :footer="null"
      :visible="addVisible"
      @cancel="handleAddCancel"
      width="900px"
    >
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-row>
          <a-col :span="17">
            <a-form-model-item label="模板标题" prop="templateTitle">
              <a-input v-model="ruleForm.templateTitle" placeholder="请输入模板标题" style="max-width:400px;"
                       :maxLength="10">
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="适用场景">
              <a-select v-model="currentTemplateId" style="max-width: 400px" @change="handleChange">
                <a-select-option :value="0">自定义</a-select-option>
                <a-select-option v-for="(item,index) in sysTemplateInfoList"
                                 :key="index"
                                 :value="item.templateId">
                  {{ item.templateTitle }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol" v-if="currentTemplateKeys.length>0">
              <a-input :maxLength="20" v-model="ruleForm.proId" style="max-width:400px;"
                       placeholder="输入商品ID可替换单个商品短信内容，默认为空"></a-input>
            </a-form-model-item>
            <a-form-model-item label="模板内容" prop="templateContent">
              <a-textarea placeholder="请填写短信文本内容，无需填写【签名】点击右侧插入自定义字段"
                          style="max-width:400px"
                          :maxLength="500" :auto-size="{ minRows: 3, maxRows: 6 }"
                          v-model="ruleForm.templateContent"
              />
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol" v-if="currentTemplateKeys.length<0">
              *最多支持5个自定义字段
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-checkbox v-model="autoOpen">通过审核后自动开启</a-checkbox>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item style="margin-top:64px;">
              <a-select v-if="currentTemplateKeys.length>0" v-model="insertContent" placeholder="请选择"
                        style="width: 200px">
                <a-select-option
                  v-for="(item,index) in currentTemplateKeys"
                  :key="index"
                  :value="item"
                >{{ item }}
                </a-select-option>
              </a-select>
              <a-input v-else v-model="insertContent" placeholder="输入自定义字段名"></a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button type="primary" style="padding:0 30px;" @click="insertTemplate">插入</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item style="text-align:center;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">添加确认</a-button>
          <a-button style="margin-left:20px;" @click="handleAddCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 添加短信签名 -->
    <a-modal
      title="添加短信签名"
      :footer="null"
      :visible="signatureVisible"
      @cancel="handleCancel"
      width='900px'
    >
      <a-form-model ref="formData" :model="formData" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="签名内容">
          <a-input v-model="formData.signatureContent" placeholder="请输入签名内容" style="max-width:400px;"
                   :maxLength="10">
          </a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          签名内容要求2~10个字，由中英文，数字组成，不支持符号，不支持全英文或全数字；
          短信签名由【】及签名内容组成，如:【魔方云】，申请时只需填写【】内文字部分，无需添加【】；
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          短信签名是作为短信发送者属性的一种标识，签名必须用于标识公司、商品或业务，禁止发送涉及：色情、赌博、毒品、党政、维权、众筹、慈善募捐、宗教、迷信、股票、移民、面试招聘、博彩、贷款、催款、信用卡提额、投资理财、中奖、抽奖、一元夺宝、一元秒杀、A货、整形、烟酒、交友、暴力、恐吓、返利、代开发票、代理注册、代办证件、加群、加QQ或者加微信、贩卖个人信息等信息的短信。
        </a-form-model-item>
        <a-form-model-item style="text-align:center;">
          <a-button type="primary" @click="addNotarize">添加确认</a-button>
          <a-button style="margin-left:20px;" @click="handleCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import TemplateComponent from '../components/SmsTemplateComponent'
import SmsComponent from '../components/SmsSignatureComponent'
import SmsShieldingSendComponent from '@/views/service/components/SmsShieldingSendComponent'

export default {
  name: 'SmsSetting',
  components: {
    SmsComponent,
    TemplateComponent,
    SmsShieldingSendComponent
  },
  data() {
    let checkSignatureContent = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('输入签名内容'))
      } else if (value.length < 2) {
        callback(new Error('输入签名内容长度要求为2~10位!'))
      } else {
        callback()
      }
    }
    let templateContent = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入模版内容'))
      } else if (value.length > 2) {
        let regular = /([{]([\u4e00-\u9fa5]||[A-Za-z0-9])*[}])/g
        let keys = value.match(regular)
        if (this.currentTemplateId < 1 && [...new Set(keys)].length > 5) {
          callback(new Error('输入的自定义字段已经超过了5个'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
        offsetCol: { offset: 5 }
      },
      submitLoading: false,
      currentTemplateId: 0,
      ruleForm: {
        templateTitle: '',
        proId: '',
        templateContent: ''
      },
      formData: {
        signatureContent: ''
      },
      rules: {
        templateTitle: [
          { required: true, message: '请输入模版标题', trigger: 'blur' }
        ],
        templateContent: [
          { required: true, message: '请输入模版内容', trigger: 'blur' },
          { validator: templateContent, trigger: 'blur' }
        ],
        signatureContent: [
          { required: true, message: '请输入签名内容', trigger: 'blur' },
          { validator: checkSignatureContent, trigger: 'blur' }
        ]
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 4 },
          lg: { span: 5 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 20 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      tabsKey: 1,
      autoOpen: true,
      isRouterAlive: true,
      addVisible: false,
      signatureVisible: false,
      form: this.$form.createForm(this),
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      sysTemplateInfoList: [],
      currentTemplateKeys: [],
      insertContent: ''
    }
  },
  mounted() {
    this.getSysTemplateInfoList()
  },
  methods: {
    callback(key) {
      this.tabsKey = key
      this.getLogUtils().logWithTag('key', key)
    },
    showTemplate() {
      this.addVisible = true
      this.$refs.ruleForm.resetFields()
    },
    showShield() {
      this.$refs.childThree.showShield()
    },
    handleAddCancel() {
      this.addVisible = false
    },
    //获取模版列表
    getSysTemplateInfoList() {
      this.getHttpServices().getSmsApiService().post('template/getSysTemplateInfoList')
        .then(res => {
          this.sysTemplateInfoList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取模版内容
    getTemplateContent(id) {
      let url = 'template/getTemplateContent/' + id
      this.getHttpServices().getSmsApiService().get(url)
        .then(res => {
          let templateContent = res.templateContent
          var regular = /([{]([\u4e00-\u9fa5]||[A-Za-z0-9])*[}])/g
          var keys = templateContent.match(regular)
          if (keys && keys.length > 0) {
            this.currentTemplateKeys = keys.map((item, index, arr) => {
              return item.replace('{', '').replace('}', '')
            })
          }
          this.ruleForm.templateContent = templateContent
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //模版插入事件
    insertTemplate() {
      if (!this.insertContent) {
        this.$message.warning('请输插入字段')
        return
      }
      this.getLogUtils().logWithTag('插入字段', this.templateContent)
      this.ruleForm.templateContent = this.ruleForm.templateContent + '{' + this.insertContent + '}'
      this.insertContent = ''
    },
    handleChange(value) {
      this.currentTemplateId = value
      this.currentTemplateKeys = []
      this.ruleForm.templateContent = ''
      this.insertContent = ''
      if (value > 0) {
        this.getTemplateContent(value)
      }
      this.getLogUtils().logWithTag('onTemplateChange', value)
    },
    showSignature() {
      this.signatureVisible = true
    },
    handleCancel(e) {
      this.signatureVisible = false
    },
    addNotarize() {
      this.getHttpServices().getSmsApiService().post('sign/insertSignature', {
        merchantId: this.merchantId,
        platformId: this.platformId,
        signature_name: this.formData.signatureContent
      })
        .then(res => {
          this.$message.success('添加签名成功')
          this.signatureVisible = false
          this.$refs.childTwo.searchBts()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!', 'error submit!!')
          return false
        }
      })
    },
    // 添加短信模板
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getSmsApiService().post('/template/insertTemplate', {
        merchantId: this.merchantId,
        platformId: this.platformId,
        content: this.ruleForm.templateContent,
        title: this.ruleForm.templateTitle,
        proId: this.ruleForm.proId,
        autoOpen: this.autoOpen ? 1 : 0,//是否自动开启 0不自动开启 1自动开启
        templateType: this.currentTemplateId > 0 ? 2 : 0,//模板类型 0自定义 1系统内置 2系统内置替换
        templateCopyId: this.currentTemplateId
      }).then(res => {
        this.addVisible = false
        this.$message.success('添加模版成功')
        //清除数据
        this.$refs.childOne.searchBts()
        this.currentTemplateId = 0
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }
}
</script>
<style scoped>
</style>